import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    border: ({ isPrivate }) =>
      `1px solid ${isPrivate ? theme.palette.primary.main : '#C6C6C6'}`,
    borderRadius: '4px',
    boxSizing: 'border-box',
    padding: '0 24px 16px 24px',
    background: ({ isPrivate }) => (isPrivate ? '#F8D8FF' : '#F5F6F8'),
    transition: 'all 250ms'
  },

  holder: {
    position: 'relative'
  }
}))

export default useStyles
